import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog, details, grid, markdown } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { editIcon, deleteIcon, addIcon, close, web, address, provisionIcon, yellowTick, expandIcon, collapseIcon } from '../../utilities/icons';
import { cache } from 'lit/directives/cache.js';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validatePhone, releaseFormLockwithBeacon } from '../../utilities/formsUtilities';
import { processZoneData } from '../../utilities/zoneUtilities';
import { getStatus } from '../../utilities/orgUtilities';
import { locationTypes } from '../../utilities/locationUtilities';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationZoneForm extends LitElement {
    static properties = {
        currentOrg: { type: String },
        name: { type: String },
        locationId: { type: String },
        zoneId: { type: String },
        view: { type: String },
        subview: { type: String },
        _zoneData: { state: true, type: Array },
        _draftZoneData: { state: true, type: Array },
        _provisionData: { state: true, type: Object },
        _isFormLocked: { state: true, type: Boolean },
        _zoneProvisions: { state: true, type: Array },
    };
    constructor() {
        super();
        this._zoneProvisions = [];
        this._zoneData = [];
        this._draftZoneData = [];
        this._provisionData = {};
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        this._organisationData = new ContextConsumer(this, { context: organisationContext, callback: this._handleContextUpdate.bind(this), subscribe: true });
        this.organisationData = this._organisationData?.value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, organisations: this.organisations, action: this.action, nonce: this.nonce, zoneProvisions: this._zoneProvisions, subview: this.subview } = this.organisationData);
        this.organisation = this._getOrganisationById(this.currentOrg);
        this.location = this._getLocationById(this.locationId);
        this.zone = this._getZoneById(this.zoneId);
        this.formID = `${this.location}-zone-form`;
        this.uid = `zone-form-${this.organisationData.user.id}`;
        this.eventManager = new EventManager(this);
        await this._setZoneData();
        this.renderRoot.querySelector('a')?.focus();
        this.eventManager.listen(`allin-location-go-back-${this.name}`, this._handleGoBack);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID, this.uid, this.restUrl, this.nonce);
    }
    async firstUpdated() {
        this._isFormLocked = await checkFormLock(this.formID, this.uid, this.restUrl, this.nonce);
        addEventListener('visibilitychange', (event) => {
            if (document.visibilityState === 'hidden') {
                releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
            }
        });
    }
    async updated(changedProperties) {
        if (changedProperties.has('subview')) {
            if (this.subview == 'edit') {
                lockForm(this.formID, this.uid, this.restUrl, this.nonce);
                this.renderRoot.querySelector('input')?.focus();
            }
            else {
                this.renderRoot.querySelector('a')?.focus();
            }
        }
        if (changedProperties.has('zoneId')) {
            this.zone = this._getZoneById(this.zoneId);
            await this._setZoneData();
            this.renderRoot.querySelector('a')?.focus();
        }
    }
    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        let main = '';
        if (!this._zoneData || this._zoneData.length == 0) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else if (this.subview == 'edit') {
            let data = this._draftZoneData.length > 0 ? this._draftZoneData : this._zoneData;
            // console.log(this._zoneData);
            if (this._isFormLocked) {
                main = html `\n                    <h3>${decodeEntities(this._zoneData.name)} details</h3>\n                    ${navigation}\n                    <div class="bg">\n                        <div class="message notice" aria-live="polite">\n                            <p>This form is currently being edited by another member of this organisation</p>\n                        </div>\n                    </div>\n                `;
            }
            else {
                let tooltip = `For more information about how to achieve this provision, please see the connected Standard (this feature is not yet implemented)`;
                let data = this._draftZoneData.length > 0 ? this._draftZoneData : this._zoneData;
                main = html `\n                    <h3>Edit details for ${decodeEntities(this._zoneData.find((item) => item.name == 'name').value)}</h3>\n                    <form @submit=${this._handleModal}>\n                        <div class="message notice" aria-live="polite">\n                            <p>Any edits will need to be reviewed and approved</p>\n                        </div>\n                        <div class="bg">\n\n                            ${data.filter(item => item.name === 'name' && item.type !== 'file').map(item => html `\n                                <div class="input-group">\n                                    <label for="${item.name}">${item.title}${item.hasOwnProperty('required') ? '*' : ''}</label>\n                                    <input\n                                    type="${item.type}"\n                                    id="${item.name}"\n                                    name="${item.name}"\n                                    value=${decodeEntities(item.value)}\n                                    @change=${this._validateURL}\n                                    />\n                                </div>\n                            `)}\n                            \n                            <allin-multiloader>\n                                ${data.map((item, i) => {
                    if (item.type !== 'file')
                        return '';
                    let show = i === 0 || item.value ? 'show' : '';
                    let fileId = '';
                    if (item.value?.publicUrl) {
                        let pattern = /%2f([^%]*)%2f/gi;
                        let matches = pattern.exec(item.value.publicUrl);
                        if (matches && matches[1]) {
                            fileId = matches[1];
                        }
                    }
                    return html `\n                                    <div class='group ${show}'>\n                                        <div class="input-group">\n                                            <allin-image-uploader inputname="${item.name}" label ="Upload an location photo" src="${item.value?.publicUrl}" labelalt="${item.name}" id="${item.name}" altrequired="${item.name}AltText" altinput="${fileId}" removeStyle="words">\n                                            </allin-image-uploader>\n                                            <label for="${item.name}AltText">ALT text</label>\n                                            <p><a href='https://design102.blog.gov.uk/2022/01/14/whats-the-alternative-how-to-write-good-alt-text/' target='_blank' rel="noopener noreferrer">View a guide on how to write alt text (opens in a new tab)</a></p>\n                                            <input type="text" name="${item.name}AltText" id="${item.name}AltText" data-label="${item.name} ALT text" data-table_label="ALT text " value="${item.value?.altText}">\n                                        </div>\n                                    </div>`;
                })}\n                            </allin-multiloader>\n\n                                ${data.filter(item => item.name !== 'name' && item.type !== 'file').map((item) => {
                    // if(item.type=='file'){
                    //     return '';
                    // }
                    let input = '';
                    if (item.type == 'checkbox') {
                        input = html `<input type="${item.type}" id="${item.name}" name="${item.name}" ?checked=${item.value} />`;
                    }
                    else if (item.type == 'multiselect') {
                        input = html `<allin-multiselect name='types' list='${JSON.stringify(locationTypes)}' label='Type' value='${JSON.stringify(item.value)}' required></allin-multiselect>`;
                    }
                    else if (item.type == 'textarea') {
                        input = html `<allin-markdown-editor name="${item.name}" id="${item.name}" description="Description" maxlength="500" placeholder="Description" value="${decodeEntities(item.value)}" ?required="${item.required}"></allin-markdown-editor>`;
                    }
                    else if (item.type == 'select') {
                        input = html `<select name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="${item.title}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''}>\n                                            <option value="">Please select</option>\n                                            ${item.options.map((option) => { return html `<option value="${option.name}" ?selected=${option.name === item.value}>${option.label}</option>`; })}\n                                        </select>`;
                    }
                    else if (item.hasOwnProperty('required')) {
                        input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" aria-required="true" name="${item.name}" value=${decodeEntities(item.value)} />`;
                    }
                    else {
                        input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" name="${item.name}" value=${decodeEntities(item.value)} data-requiredif="${item.requiredIf}" />`;
                    }
                    return html `\n                                    <div class="input-group">\n                                        <label for="${item.name}">${item.title}${item.hasOwnProperty('required') ? '*' : ''}</label>\n                                        ${input}\n                                    </div>\n                                `;
                })} \n                                ${this._zoneProvisions.map((_provision) => {
                    let icon = _provision.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                    return html `\n                                        <details class="provisions">\n                                            <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${_provision.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} />${_provision.title}</summary>\n                                            <div class="panel">\n                                                ${_provision.provisions.map((provision) => {
                        let checked, description, image, altText, imageId;
                        let thisProvisionData = this._provisionData.find((item) => {
                            return item.standardId == provision.id;
                        });
                        let id = `provision__${provision.id}`;
                        if (thisProvisionData) {
                            checked = true;
                            description = thisProvisionData?.description;
                            image = thisProvisionData?.image;
                            imageId = thisProvisionData?.imageId;
                            altText = thisProvisionData?.alt;
                        }
                        return html `\n                                                        <div class="provision">\n                                                            <div class="input-group">\n                                                                <input type="checkbox" name="${id}" id="${id}" ?checked=${checked} data-table_label="Provision">\n                                                                <label for="${id}">${provision.name}</label>\n                                                            </div>\n                                                                <p class="small">${provision.description}</p>\n                                                                <div class="hidden">\n                                                                    <label for="${id}_description">Explain how you implement this</label>\n                                                                    <allin-markdown-editor name="${id}_description" id="${id}_description" data-label="${provision.name} description" data-table_label="Description" placeholder="Description" value="${description}"></allin-markdown-editor>\n                                                                    <allin-image-uploader inputname="${id}_photo" label ="Upload a supporting image" src="${image}" labelalt="${provision.name} supporting image" tablelabelalt="Supporting image" id="${id}" altrequired="${id}_photoAltText" altinput="${imageId}">\n                                                                    </allin-image-uploader>\n                                                                    <label for="${id}_photoAltText">Please include ALT text</label>\n                                                                    <p><a href="https://design102.blog.gov.uk/2022/01/14/whats-the-alternative-how-to-write-good-alt-text/" target="_blank">View a guide on how to write alt text (opens in a new tab).</a></p>\n                                                                    <input type="text" name="${id}_photoAltText" id="${id}_photoAltText" data-label="${provision.name} ALT text" data-table_label="ALT text " value="${altText}">\n                                                                </div>\n                                                                <allin-tooltip tooltip="${provision.more_info ? provision.more_info : tooltip}"></allin-tooltip>\n                                                            </div>\n                                                        </div>\n                                                    `;
                    })}\n                                            </div>\n                                        </details>\n                                    `;
                })}\n                                <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                                <input type="hidden" name="location_id" value="${this.locationId}" />\n                                <input type="hidden" name="zone_id" value="${this.zoneId}" />\n                                <input type="hidden" name="action" value="${this.action}-edit-zone" />\n                                <div class="button-group">\n                                    <button type="submit">Save changes and submit for approval</button>\n                                </div>   \n                                <hr>\n                                <a href="javascript:void(0)" @click=${this._handleClick}>${deleteIcon}Cancel</a>\n                        </div>\n                    </form> \n                    <dialog>\n                        <button class="close" autofocus @click=${this._handleModal}><span aria-hidden="true">${deleteIcon}</span>Cancel</button>\n                        <p>\n                            Thank you for submitting your changes for approval. You can still make and preview changes.\n                        </p>\n                        <button @click=${this._handleSubmit}>Submit for approval</button>\n                    </dialog>\n                `;
            }
        }
        else {
            let data = this._draftZoneData.length > 0 ? this._draftZoneData : this._zoneData;
            let cta = html `<hr><a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit these details</a>`;
            if (this.zone.approvalStatus == 'AwaitingResponse') {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>Thank you for submitting your zone. It is now awaiting approval. You will now be able to preview your public profile and make changes to your zone.</p>\n                    </div>\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit submission</a>\n                `;
            }
            else if (this.zone.approvalStatus == 'NewApplication') {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>Your application hasn't been submitted yet</p>\n                    </div>\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit submission</a>\n                    `;
            }
            let loop = [];
            let descriptionD = data.find((item) => item.name == 'description');
            if (descriptionD.value) {
                loop.push(html `<div class="item text">\n                        <p><strong>Description:</strong></p>\n                        <allin-markdown-editor value="${decodeEntities(descriptionD.value)}" readonly></allin-markdown-editor>\n                    </div>`);
            }
            let typeD = data.find((item) => item.name == 'zoneType');
            if (typeD.value) {
                loop.push(html `<div class="item text">\n                        <p><strong>Type:</strong></p>\n                        <p>${typeD.value}</p>\n                    </div>`);
            }
            let visualStoryD = data.find((item) => item.name == 'visualStory');
            if (visualStoryD.value) {
                loop.push(html `<div class="item text">\n                        <p><strong>Visual Story URL:</strong></p>\n                        <p><a href="${visualStoryD.value}" target="_blank">${visualStoryD.value}</a></p>\n                    </div>`);
            }
            let photo1D = data.find((item) => item.name == 'photo1');
            let photo2D = data.find((item) => item.name == 'photo2');
            let photo3D = data.find((item) => item.name == 'photo3');
            if (photo1D.value || photo2D.value || photo3D.value) {
                loop.push(html `<p><strong>Gallery</strong></p>`);
                if (photo1D.value && photo1D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo1D.value.publicUrl}" alt="${photo1D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo1D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo2D.value && photo2D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo2D.value.publicUrl}" alt="${photo2D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo2D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo3D.value && photo3D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo3D.value.publicUrl}" alt="${photo3D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo3D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
            }
            let provisionsLoop = this._zoneProvisions.map((_provision) => {
                let markup = [];
                let hasDraft = false;
                _provision.provisions.forEach((provision) => {
                    let thisProvisionData = this._provisionData.find((item) => {
                        return item.standardId == provision.id;
                    });
                    if (thisProvisionData) {
                        let description = thisProvisionData?.description;
                        let image = thisProvisionData?.image;
                        let altText = thisProvisionData?.alt;
                        let isDraft = thisProvisionData?.draft == true;
                        if (isDraft) {
                            hasDraft = true;
                        }
                        markup.push(html `\n                            <div class="provision item grid grid--icon ${isDraft ? 'draft' : ''}">\n                                <div class="icon">${yellowTick}</div>\n                                <div class="text">\n                                    <p><strong>${provision.name}</strong> ${isDraft ? html `<span class="is_draft">Awaiting approval</span>` : ''}</p>\n                                    <allin-markdown-editor value="${description}" readonly></allin-markdown-editor>\n                                    ${image ? html `<img class="provision_image" width="200" height="130" src="${image}" alt="${altText}" />` : ''}\n                                </div>\n                            </div>\n                                \n                        `);
                    }
                });
                if (markup.length == 0) {
                    return '';
                }
                let icon = _provision.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                return html `\n                    <details class="provisions">\n                    <summary>\n                        <img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${_provision.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                    e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                } }} />\n                        <span>${_provision.title}</span>\n                        ${hasDraft ? html `<p class="has_draft">This provision has changes awaiting approval</p>` : ''}\n                    </summary>\n                    <div class="panel">\n                        ${markup}\n                    </panel>\n                </details>\n                `;
            });
            let hasProvisions = provisionsLoop.filter((item) => item != '');
            let provisionsPre = '';
            if (hasProvisions.length == 0) {
                provisionsPre = html `<p class="small">No provisions have been added to this zone yet or they may be waiting approval</p>`;
            }
            else {
                provisionsPre = html `<div class="collapsers">\n                    <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all provisions</button>\n                    <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all provisions</button>\n                </div>`;
            }
            main = html `\n                <h3>${decodeEntities(this._zoneData.find((item) => item.name == 'name').value)} details</h3>\n                <div class="bg">\n                    ${loop} \n                    ${provisionsPre}\n                    ${provisionsLoop}\n                    ${cta}   \n                </div>\n            `;
        }
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.subview = this.subview == 'edit' ? '' : 'edit';
    }
    _handleGoBack() {
        this._handleChangeView(null, '');
    }
    _handleChangeView(e, view = null) {
        if (e) {
            e.preventDefault();
            let button = e.target;
            view = button.id;
            if (view == 'details') {
                view = '';
            }
        }
        let oldView = this.subview;
        this.subview = view;
        if (this.subview == oldView) {
            return;
        }
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/locations/' + this.location + '/zones/' + this.zone + '/' + this.subview, { panel: this.zone, view: this.subview });
        if (!this.subview && oldView) {
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name} Dashboard` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Locations` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}`, title: decodeEntities(this.location.name) }
            };
            if (oldView == 'preview') {
                this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
            }
        }
        else if (this.subview) {
            let name = '';
            if (this.subview == 'zone') {
                name = `Manage zones for ${this._locationData.name}`;
                if (oldView == 'preview') {
                    this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
                }
            }
            else if (this.subview == 'preview') {
                name = `Listing view`;
            }
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name} Dashboard` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Locations` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location}`, title: decodeEntities(this.location.location_data.name) },
                view: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location}/${this.zone}`, title: `Manage zones for ${this.location.location_data.name}` },
                subview: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location}/${this.zone}/${this.subview}`, title: name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        }
    }
    _handleModal(e) {
        e.preventDefault();
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    async _handleSubmit(e) {
        e.preventDefault();
        this._modal.close();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                let zone = JSON.parse(response.data);
                let zoneIndex = this.location.location_data.zones.findIndex((zone) => zone.id == this.zoneId);
                if (zoneIndex !== -1) {
                    this.location.location_data.zones[zoneIndex] = zone;
                }
                this.zone = zone;
                let locationIndex = this.organisation.locations.findIndex((loc) => loc.id == this.location.id);
                if (locationIndex !== -1) {
                    this.organisation.locations[locationIndex] = this.location;
                    this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
                }
                await this._setZoneData();
                submitButton.disabled = false;
                this.view = false;
                this.subview = false;
            }
            else {
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    async _setZoneData() {
        if (!this._zoneProvisions.length) {
            await this._fetchAllProvisions();
        }
        if (!this.zone) {
            this.zone = this._getZoneById(this.zoneId);
        }
        let processedData = processZoneData(this.zone);
        if (processedData) {
            ({ zoneData: this._zoneData, draftZoneData: this._draftZoneData, provisionData: this._provisionData } = processedData);
        }
        else {
            this.zone = {};
        }
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _getLocationById(id) {
        if (!this.organisation?.locations)
            return null;
        if (!this.organisation?.locations?.length)
            return null;
        let lId = this.organisation?.locations?.find((loc) => loc.id == id);
        return lId;
    }
    _getZoneById(id) {
        let zId = this.location?.location_data?.zones?.find((zone) => zone.id == id);
        return zId;
    }
    async _fetchAllProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions-zones-all&nonce=${this.nonce}`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this._zoneProvisions = data.zoneProvisions;
            this._loading = false;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { zoneProvisions: JSON.stringify(this._zoneProvisions) });
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _handleContextUpdate(value) {
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, nonce: this.nonce, zoneProvisions: this._zoneProvisions } = this.organisationData);
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _handleCollapse(e) {
        let target = e.currentTarget.dataset.collapse;
        if (target) {
            let targets = this.shadowRoot.querySelectorAll(`.${target}`);
            if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                targets.forEach(target => target.classList.remove('open'));
            }
            else {
                e.currentTarget.setAttribute('aria-expanded', 'true');
                targets.forEach(target => target.classList.add('open'));
            }
        }
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }

        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            box-sizing: border-box;
            overflow:visible;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions img:not(.provision_image){
            object-fit:contain;
            object-position:top left;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .provision .text img{
            width:200px;
            height:130px;
            object-fit:contain;
        }

        .provision input-group label{
            margin-left: 0.5rem;
        }

        .has_draft{
            font-weight:400;
            font-size:1rem;
            color:#555;
            grid-column:1 / -1;
        }

        .is_draft{
            font-weight:400;
            font-size:1rem;
            color:#555;
        }

        p:has(.is_draft){
            display:flex;
            justify-content:space-between;
        }
        `
    ];
}
